import React, { Fragment, useState, useEffect, useRef } from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import { Card, CardBody, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import { FileText } from 'react-feather';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {H5, H4, H6, P, Image, Btn, H2, Breadcrumbs} from '../../../../AbstractElements';
import {Save, Address, PostalCode, Country, City, State, Telephone, TypeOfService, DateOfSubmission, DateOfContractTermination, FieldCannotBeEmpty, PleaseEnterValidEmail, PleaseEnterValidPhoneNumber, Email, DeleteTxt } from '../../../../Constant';
import {db, firebase_rdb} from '../../../../Config/Config';
import {doc, getDoc} from "firebase/firestore";
import DatePicker from "react-datepicker";
import i18n from '../../../../i18n';
import {
    createAdminOperationTracker,
    performAdminDataMutation,
} from '../../../../utils/adminDataMutationClient';

const CLIENT_ID = 'maxpark-220731';
const CONTRACTS_PATH = `clients/${CLIENT_ID}/contrats`;
const CONTRACTS_COLLECTION = `clients/${CLIENT_ID}/contrats`;

// pdfmake 0.2.23 exports the virtual file system directly.
pdfMake.addVirtualFileSystem(pdfFonts);

const toDate = (value) => {
    if (!value) return null;
    if (typeof value.toDate === 'function') return value.toDate();
    if (value.seconds) return new Date(value.seconds * 1000);

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const serializeContractDate = (value) =>
    value instanceof Date ? value.toISOString() : value || '';

const SingleContractPage = () => {

    const { id } = useParams();

    const [editMode, setEditMode] = useState(false);
    const [archivedContract, setArchivedContract] = useState(false);
    const [mutationPending, setMutationPending] = useState(false);
    const [mutationError, setMutationError] = useState('');
    const operationTrackerRef = useRef(null);

    if (!operationTrackerRef.current) {
        operationTrackerRef.current = createAdminOperationTracker();
    }

    const [shouldRedirect, setShouldRedirect] = useState(false);

    const [currentClient , setCurrentClient] = useState('Maxpark Solutions');

    const [contractData, setContractData] = useState([]);

    const [contractClient, setClient] = useState('');
    const [contractContact, setContact] = useState('');
    const [contractEmail, setEmail] = useState('');
    const [contractTypeOfService ,setTypeOfService] = useState('');
    const [contractDateOfSubmission, setDateOfSubmission] = useState();
    const [contractEndOfContract ,setEndOfContract] = useState();
    const [contractAddress ,setAddress] = useState('');
    const [contractCity ,setCity] = useState('');
    const [contractState ,setState] = useState('');
    const [contractPostalCode ,setPostalCode] = useState('');
    const [contractCountry, setCountry] = useState('');
    const [contractTelephone, setTelephone] = useState('');
    const [contractTelExtension ,setExtension] = useState('');


    const fetchData = async () => {
        const contractId = id.toString();
        const [firestoreResult, realtimeResult] = await Promise.allSettled([
            getDoc(doc(db, CONTRACTS_COLLECTION, contractId)),
            firebase_rdb
                .child(CONTRACTS_PATH)
                .child(contractId)
                .once('value'),
        ]);
        const firestoreData = firestoreResult.status === 'fulfilled' && firestoreResult.value.exists()
            ? firestoreResult.value.data()
            : null;
        const realtimeData = realtimeResult.status === 'fulfilled'
            ? realtimeResult.value.val()
            : null;

        if (firestoreResult.status === 'rejected') {
            console.error('Error reading Firestore contract:', firestoreResult.reason);
        }
        if (realtimeResult.status === 'rejected') {
            console.error('Error reading realtime contract:', realtimeResult.reason);
        }

        const isArchived = firestoreData?.archived === true || realtimeData?.archived === true;
        setArchivedContract(isArchived);
        setEditMode(false);
        const data = firestoreData || realtimeData || {};

        if (!data || Object.keys(data).length === 0) {
            console.error('Contract not found:', contractId);
            return;
        }

        setContractData(data);
        setFields(data);
        reset({
            ...data,
            dateOfSubmission: toDate(data.dateOfSubmission),
            endOfContract: toDate(data.endOfContract)
        });
    }

    const { register, handleSubmit, formState: {errors}, control, reset} = useForm();

    const contractPdf = {
        content: [
            {text: currentClient, style: 'header'},
            "Ce contrat désigne l'offre d'entente entre "+currentClient+ " et " +contractClient+".",
            {text: 'Détails', style: 'subheader'},
            'Exemple',
            {
                style: 'tableExample',
                table: {
                    widths: [100, '*', 200, '*'],
                    body: [
                        ['Contact', 'Email', 'Type of service', 'Date of submission'],
                        [contractClient, {text: contractEmail, italics: true, color: 'gray'}, {text: contractTypeOfService, italics: true, color: 'gray'}, {text: contractDateOfSubmission, italics: true, color: 'gray'}]
                    ]
                }
            },

            {text: 'Autre valeurs du contrat', style: 'subheader'},
            'Affichage superposé:',
            {
                bold: true,
                ul: [
                    'Test 1',
                    'Test 2 ',
                    'Test 3'
                ]
            },
            {
                style: 'tableExample',
                table: {
                    widths: [100, '*', 200, '*'],
                    body: [
                        ['Address', 'City', 'State', 'Country'],
                        [contractAddress, {text: contractCity, italics: true, color: 'gray'}, {text: contractState, italics: true, color: 'gray'}, {text: contractCountry, italics: true, color: 'gray'}]
                    ]
                }
            },

        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
        }

    };

    const setFields = (data) => {
        setClient(data.client);
        setContact(data.contact);
        setEmail(data.email),
        setTypeOfService(data.typeOfService);
        setDateOfSubmission(toDate(data.dateOfSubmission));
        setEndOfContract(toDate(data.endOfContract));
        setAddress(data.address);
        setCity(data.city);
        setState(data.state);
        setPostalCode(data.postalCode);
        setCountry(data.country);
        setTelephone(data.telephone);
        setExtension(data.telExtension);
    }

    const formSubmit = async (data) => {
        if (archivedContract) {
            setMutationError("Ce contrat est archive et ne peut plus etre modifie.");
            return;
        }
        const updatedContractData = {
            client: data.client,
            contact: data.contact,
            email: data.email,
            telephone: data.telephone,
            telExtension: data.telExtension,
            typeOfService: data.typeOfService,
            dateOfSubmission: serializeContractDate(data.dateOfSubmission),
            endOfContract: serializeContractDate(data.endOfContract),
            address: data.address,
            city: data.city,
            state: data.state,
            postalCode: data.postalCode,
            country: data.country
        };
        const operation = 'contract.update';
        const subjectId = id.toString();
        const operationId = await operationTrackerRef.current.forSubmission({
            operation,
            subjectId,
            fields: updatedContractData,
        });

        setMutationPending(true);
        setMutationError('');
        try {
            await performAdminDataMutation({
                operation,
                operationId,
                subjectId,
                fields: updatedContractData,
            });
            operationTrackerRef.current.markSucceeded();
            setEditMode(false);
            setContractData({ ...contractData, ...updatedContractData, id: subjectId });
            setFields(updatedContractData);
        } catch (error) {
            setMutationError(error.message || "Impossible de sauvegarder le contrat pour le moment.");
        } finally {
            setMutationPending(false);
        }
    }

    const handleDelete = async () => {
        if (archivedContract) {
            setMutationError("Ce contrat est deja archive.");
            return;
        }
        if (window.confirm(i18n.t('Dashboard_Contracts_DeleteConfirm')))
        {
            const operation = 'contract.delete';
            const subjectId = id.toString();
            const fields = {};
            const operationId = await operationTrackerRef.current.forSubmission({ operation, subjectId, fields });
            setMutationPending(true);
            setMutationError('');
            try {
                await performAdminDataMutation({ operation, operationId, subjectId, fields });
                operationTrackerRef.current.markSucceeded();
                setArchivedContract(true);
                setShouldRedirect(true);
            } catch (error) {
                setMutationError(error.message || "Impossible d'archiver le contrat pour le moment.");
            } finally {
                setMutationPending(false);
            }
        }
    }

    const navigate = useNavigate();
    useEffect(() => {
        if(shouldRedirect) {
            navigate('/dashboard/contracts');
        }
    }, [shouldRedirect])

    useEffect(() => {
        fetchData();
    }, [reset])

    return (
        <Fragment>
            <Breadcrumbs mainTitle='Contrats' parent={i18n.t('Dashboard_Common_Dashboard')} title={i18n.t('Dashboard_Breadcrumb_GeneralInfo')} />
            <Card>
                <CardBody>
                    {archivedContract ? <p className="text-warning">Ce contrat est archive.</p> : null}
                    {mutationError ? <p className="text-danger">{mutationError}</p> : null}
                    <Form onSubmit={handleSubmit(formSubmit)}>
                        <Row className="">
                            <Col md="8">
                                <H2 attrH6={{ className: 'title' }}>Modifications d'un contrat</H2>
                                <P>Cette liste contient tous les contrats.</P>
                            </Col>
                            <Col md="4">
                                <button type='button' onClick={() => {pdfMake.createPdf(contractPdf).download();}} className='btn btn-secondary btn-block pull-right'><FileText className="h-15"/>{i18n.t('Dashboard_Contracts_ExportNotice')}</button>

                            </Col>
                        </Row>
                        <Row className="m-t-50">
                            <Col md="9">
                                <Row>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">Client</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register('client')}></input>
                                            <p>{errors.client? FieldCannotBeEmpty : ''}</p>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">Contact</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register('contact')}></input>
                                            <p>{errors.contact? FieldCannotBeEmpty : ''}</p>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">{Email}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("email", { pattern: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i})}></input>
                                            <p>{errors.email? PleaseEnterValidEmail : ''}</p>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">{Telephone}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("telephone", { pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im})}></input>
                                            <p>{errors.telephone? PleaseEnterValidPhoneNumber : ''}</p>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">{i18n.t('Dashboard_Contracts_Extension')}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register('telExtension')}></input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup className="mb-6">
                                            <Label className="form-label">{TypeOfService}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register('typeOfService')}></input>
                                            <p>{errors.typeOfService? FieldCannotBeEmpty : ''}</p>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup><Label className="form-label">{DateOfSubmission}</Label>
                                            <Controller
                                                control={control}
                                                name="dateOfSubmission"
                                                // defaultValue={contractDateOfSubmission}
                                                render={({ field: { onChange, onBlur, value}}) => (
                                                    <DatePicker
                                                        onChange={onChange}
                                                        onBlur={onBlur}
                                                        selected={value}
                                                        className="form-control"
                                                        disabled={editMode ? false : true}
                                                    />
                                                )}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="6">
                                        <FormGroup><Label className="form-label">{DateOfContractTermination}</Label>
                                            <Controller
                                                control={control}
                                                name="endOfContract"
                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                    <DatePicker
                                                        onChange={onChange}
                                                        onBlur={onBlur}
                                                        selected={value}
                                                        className="form-control"
                                                        disabled={editMode ? false : true}
                                                    />
                                                )}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup><Label className="form-label">{Address}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("address")}></input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="4">
                                        <FormGroup> <Label className="form-label">{City}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("city")}></input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="4">
                                        <FormGroup> <Label className="form-label">{State}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("state")}></input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6" sm="6" md="4">
                                        <FormGroup><Label className="form-label">{PostalCode}</Label>
                                            <input className="form-control" type="text" disabled={editMode ? false : true} {...register("postalCode")}></input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup><Label className="form-label">{Country}</Label>
                                            <input type="text" className="form-control btn-square" disabled={editMode ? false : true} {...register("country")}></input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <div className="form-footer">
                            <button type='button' className='btn btn-secondary btn-block m-t-30 pull-left'
                                    disabled={archivedContract || mutationPending}
                                    onClick={() => setEditMode(!editMode)}>{!editMode ? i18n.t('Dashboard_Common_Edit') : i18n.t('Dashboard_Common_Cancel')} </button>
                            {!editMode ? '' : <button type='button' className='btn btn-danger btn-block m-t-30 m-l-10 pull-left'
                                                              onClick={handleDelete}>{DeleteTxt}</button>}
                            <button type='submit' disabled={!editMode || archivedContract || mutationPending} className='btn btn-primary btn-maxpark btn-block m-t-30 pull-right'>{Save}</button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    );
};
export default SingleContractPage;
